export function accessNestedProperty (obj, addrs, newVal) {  
  
    //allow to get or set a field in an object tree based on array containing address of that field

    const isChange = typeof newVal !== 'undefined';
    let value = obj;
    let upperLimit = isChange ? addrs.length - 1 : addrs.length;
    
    for (let i = 0; i < upperLimit; i++) {
      value = value[addrs[i]];
    
    }  
    
    if (isChange) {
      //set
      value[addrs[upperLimit]] = newVal;
    } else {
      //get
      return value;
    }  
  
  }